export default function findColumnWithValue(columns, value) {
    for (let i=0; i<columns.length; i++) {
        const col = columns[i];
        if (col.value === value) {
            return col;
        }
    }
}